import {
  FEATURE_FLAG_CONNECTIONS_TYPE,
  FEATURE_FLAG_FREE_METABASE_AI_TYPE,
  FEATURE_FLAG_INCLUDE_DWH_RENT_TYPE,
  FEATURE_FLAG_MAGIC_LOGIN_LINKS_TYPE,
  FEATURE_FLAG_METABASE_AI_TYPE,
  FEATURE_FLAG_OFFER_METABASE_AI_MANAGED_TYPE,
  FEATURE_FLAG_OFFER_IP_ALLOWLIST_TYPE,
  FEATURE_FLAG_OFFER_METERED_TRANSFORMS_TYPE,
  FEATURE_FLAG_OFFER_PRODUCT_ANALYTICS_TYPE,
  FEATURE_FLAG_STANDBY_INSTANCES_TYPE,
} from "./constants";
import { FeatureFlagType, IConfig } from "./types";

export const getFeatureFlagValue = (
  config: Pick<IConfig, "feature_flags">,
  id: FeatureFlagType,
) => config.feature_flags?.find((flag) => flag.id === id)?.value || false;

const createGetFeatureFlagValue =
  (id: FeatureFlagType) => (config: Pick<IConfig, "feature_flags">) =>
    getFeatureFlagValue(config, id);

export const areMagicLinksAllowed = createGetFeatureFlagValue(
  FEATURE_FLAG_MAGIC_LOGIN_LINKS_TYPE,
);

export const hasStandbyInstances = createGetFeatureFlagValue(
  FEATURE_FLAG_STANDBY_INSTANCES_TYPE,
);

export const areConnectionsAllowed = createGetFeatureFlagValue(
  FEATURE_FLAG_CONNECTIONS_TYPE,
);

export const hasMetabaseAI = createGetFeatureFlagValue(
  FEATURE_FLAG_METABASE_AI_TYPE,
);

export const hasFreeMetabaseAI = createGetFeatureFlagValue(
  FEATURE_FLAG_FREE_METABASE_AI_TYPE,
);

export const offerManagedMetabaseAI = createGetFeatureFlagValue(
  FEATURE_FLAG_OFFER_METABASE_AI_MANAGED_TYPE,
);

export const offerMeteredTransforms = createGetFeatureFlagValue(
  FEATURE_FLAG_OFFER_METERED_TRANSFORMS_TYPE,
);

export const offerDWHRent = createGetFeatureFlagValue(
  FEATURE_FLAG_INCLUDE_DWH_RENT_TYPE,
);

export const offerProductAnalytics = createGetFeatureFlagValue(
  FEATURE_FLAG_OFFER_PRODUCT_ANALYTICS_TYPE,
);

export const offerIPAllowlist = createGetFeatureFlagValue(
  FEATURE_FLAG_OFFER_IP_ALLOWLIST_TYPE,
);
